import request from "@/utils/request";

// 运营商修改全局配置
export default function editConfigs(data) {
  return request({
    url: `/common/agent/agentConfig/edit`,
    method: "post",
    data,
  });
}
